import Cookies from "js-cookie";

function get(key, isJson) {
  let data = Cookies.get(key);
  if (isJson && data) data = JSON.parse(data);
  return data;
}

function set(key, data, expires) {
  return Cookies.set(key, data, { expires });
}

function remove(key) {
  return Cookies.remove(key);
}

export default {
  get,
  set,
  remove
};
